import { useQuery } from '@tanstack/react-query'

import { supabase } from '@/lib/supabase/cliente'
import { mensajeDeError } from '@/lib/supabase/errores'
import type { MiHistorial } from '@/lib/supabase/tipos-bd'
import { conRespaldo } from '@/lib/campo/loUltimoQueSeSupo'

/**
 * Los trabajos terminados del operario, con su evidencia.
 *
 * Solo lectura: es su registro de lo hecho. Las fotos llegan como rutas del
 * bucket privado; para verlas hace falta una URL firmada (useEvidencia).
 */
export function useMiHistorial() {
  const consulta = useQuery({
    queryKey: ['mi-historial'],
    staleTime: 60 * 1000,
    queryFn: () =>
      conRespaldo<MiHistorial[]>('mi-historial', async () => {
        const { data, error } = await supabase.rpc('fn_mi_historial')

        if (error) throw new Error(mensajeDeError(error))

        return ((data ?? []) as unknown as MiHistorial[]).map((fila) => ({
          ...fila,
          horas_ejecutadas: Number(fila.horas_ejecutadas),
          horas_extra: Number(fila.horas_extra),
          fotos: Array.isArray(fila.fotos) ? fila.fotos : [],
        }))
      }),
  })

  return {
    historial: consulta.data ?? [],
    cargando: consulta.isLoading,
    error: consulta.error?.message ?? null,
  }
}
